module.exports = __webpack_public_path__ + "static/media/header-bg-1.1be99a59.jpg";